import { render, staticRenderFns } from "./WizardButton.global.vue?vue&type=template&id=5aa07288&scoped=true&lang=pug&"
import script from "./WizardButton.global.vue?vue&type=script&lang=ts&"
export * from "./WizardButton.global.vue?vue&type=script&lang=ts&"
import style0 from "./WizardButton.global.vue?vue&type=style&index=0&id=5aa07288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa07288",
  null
  
)

export default component.exports